module.exports = __webpack_public_path__ + "img/marker.7de6ee72.svg";